import { render, staticRenderFns } from "./LandownerTab.vue?vue&type=template&id=4a2f0844"
import script from "./LandownerTab.vue?vue&type=script&lang=js"
export * from "./LandownerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports